//React
import React from "react";
import {
  Link
} from "react-router-dom";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as communityQaAction from '../action/communityQaAction';
import * as partnerAction from '../action/partnerAction';
import * as partnerOperationAction from '../action/partnerOperationAction';
//Material-ui
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Fab from '@material-ui/core/Fab';

//Func
import atom2datetime from '../func/atom2datetime';
//Part
import MenuCommunity from './MenuCommunity';
import PartUserMainImg from './PartUserMainImg';
import PartUserName from './PartUserName';
import PartPagingNextPrev from './PartPagingNextPrev';
import PartCommunityQaStatistics from './PartCommunityQaStatistics';
//Dialog
import DialogQaAnswerAddConfirm from './DialogQaAnswerAddConfirm';
import DialogConfirm from './DialogConfirm';

//Icon
import RefreshIcon from '@material-ui/icons/Refresh';
import CancelIcon from '@material-ui/icons/Cancel';
import MoreVertSharpIcon from '@material-ui/icons/MoreVertSharp';
import CreateIcon from '@material-ui/icons/Create';


class Comp extends React.Component {

  constructor(props) {
    super(props);

  	this.state = {
      pic: null,
      answerAddQaId: null,
      answerAddText: '',
      answerDelQaId: null,
  	}
  }

  componentDidMount() {
    document.title = 'みんなのQ&A - パートナーズ';
    let datetime = new Date();
    if ((datetime - this.props.communityQa.datetime) > (60*60*1000)) {
      this.props.communityQaListGet(this.props.communityQa.page)
    }
    else {
      window.scrollTo(0, this.props.communityQa.scrollpos);
    }
  }

  componentWillUnmount() {
    this.props.communityQaScrollposEdit(window.pageYOffset);
  }

  _onPaging(page) {
    this.props.communityQaListGet(page);
    window.scrollTo(0, 0);
  }



	_renderList = (item, index) => {
    let answerComp;
    if ((item.qa_question_list === 2 && item.oppositeSexCheck === false) || (item.qa_question_list === 3 && item.oppositeSexCheck === true)) {

      answerComp = (
        <>
          {
            (Array.isArray(item.qa_answer) === true) && (
              item.qa_answer.map(
                (value, index) => this._renderAnswer(value, index, item.userdata_id_code, item.qa_id, true)
              )
            )
          }
          <div style={{margin:'10px'}} align='center'>
            <Button
              size="large"
              variant="outlined"
              style={{textAlign:'left'}}
              onClick={ () => this._answerStatisticsToggle(item.qa_id) }
            >
              みんなの回答を見る
            </Button>
          </div>

        </>
      )
    }
    else {
      answerComp = (
        <>
          {
            (item.qa_my_answer) ? (
              <>
                <div>
                  { this._renderMyAnswer(item.qa_my_answer, item.qa_id) }
                </div>
                <div style={{margin:'10px'}} align='center'>
                  <Button
                    size="large"
                    variant="outlined"
                    style={{textAlign:'left'}}
                    onClick={ () => this._answerStatisticsToggle(item.qa_id) }
                  >
                    みんなの回答を見る
                  </Button>
                </div>
              </>
            ):(
              (Array.isArray(item.qa_answer) === true) && (
                item.qa_answer.map(
                  (value, index) => this._renderAnswer(value, index, item.userdata_id_code, item.qa_id, false)
                )
              )
            )
          }
        </>
      )
    }

		return (
			<div key={index} className='box_outer'>
				<Box className='box_inner round12' boxShadow={2}>
					<div style={{padding:'2%'}}>
            <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'top'}}>
              <div style={{display:'flex',flexDirection:'row',justifyContent:'start'}}>
                {
                  (item.oppositeSexCheck) && (
                    <div style={{width:'55px'}}>
                      <Link to={{ pathname: '/partner/' + item.userdata_id_code}}>
                        <PartUserMainImg
                          mainImg={item.userdata_mainImg}
                          width={'50px'}
                          height={'50px'}
                          radius={'50%'}
                        />
                      </Link>
                    </div>
                  )
                }
                <div>
                  <div>
                    {
                      (item.oppositeSexCheck) ? (
                        <Link to={{ pathname: '/partner/' + item.userdata_id_code}}>
                          <PartUserName
                            data={{
                              name: item.userdata_name,
                              sex: item.userdata_sex,
                              size: '1.2em',
                            }}
                          />
                        </Link>
                      ): (
                        <PartUserName
                          data={{
                            name: item.userdata_name,
                            sex: item.userdata_sex,
                            size: '1.2em',
                          }}
                        />
                      )
                    }
                    <span style={{marginLeft:'10px',color:'#222'}}>{item.userdata_age}才 {item.userdata_prof_region}</span>
                  </div>
                  <div style={{color:'#666'}}>{atom2datetime(item.qa_date_atom, 'D')}</div>
                </div>
              </div>
              <div>
                <IconButton
                  onClick={ () => this.props.partnerOperationOpen(item.userdata_id_code, ['memo', 'nondisplay','refusal','breach']) }
                >
                  <MoreVertSharpIcon />
                </IconButton>
              </div>
            </div>


						<div style={{margin:'10px',fontSize:'1.1em',fontWeight:'bold',color:'#333',whiteSpace:'pre-line'}}>
              {item.qa_question}
            </div>
            {
              (item.qa_question_list === 2) && (
                <span className='orange-o_icon'>
                  この質問は{(item.userdata_sex === 'men') ? '女性' : '男性'}だけが回答できます
                </span>
              )
            }
            {
              (item.qa_question_list === 3) && (
                <span className='orange-o_icon'>
                  この質問は{(item.userdata_sex === 'men') ? '男性' : '女性'}だけが回答できます
                </span>
              )
            }
            { answerComp }
            <div>
              {
                (item.statistics) && (
                  <PartCommunityQaStatistics
                    qaId={item.qa_id}
                    statistics={item.statistics}
                  />
                )
              }
            </div>
					</div>
				</Box>
			</div>
		);
	};

  _renderMyAnswer(qa_my_answer, qa_id) {
		return (
			<div style={{margin:'5px'}}>

        <span className='orange_icon'>回答済み</span>
        { qa_my_answer }

        <CancelIcon
          onClick={ () => this.setState({answerDelQaId:qa_id}) }
          style={{
            verticalAlign:'middle',
            cursor:'pointer',
            color:'#ccc',
          }}
        />


			</div>
		);
	}

  _renderAnswer(value, index, pic, qa_id, disabled) {
		return (
			<div key={index} style={{margin:'5px'}}>
        <Button
          size="large"
          variant="outlined"
          onClick={ () => this.setState({pic:pic, answerAddQaId:qa_id, answerAddText:value}) }
          style={{textAlign:'left'}}
          disabled={disabled}
        >
          { value }
        </Button>

			</div>
		);
	}

  _partnerQaQuestionAnswerAddSubmit(qaAnswerOpen) {
    this.props.partnerQaQuestionAnswerAdd(this.state.answerAddQaId, qaAnswerOpen, this.state.answerAddText, () => {
      this.setState({answerAddQaId:null, answerAddText:''})
    })
  }

  _partnerQaQuestionAnswerDelSubmit() {
        this.props.partnerQaQuestionAnswerDel(this.state.answerDelQaId, () => {
      this.setState({answerDelQaId: null})
    })
  }

  _answerStatisticsToggle(qaId) {
    let index = this.props.communityQa.list.findIndex((v) => v.qa_id === qaId);
		if (this.props.communityQa.list[index].statistics) {
      this.props.communityQaStatisticsDel(qaId);
    }
    else {
      this.props.communityQaStatisticsGet(qaId);
    }
  }

	render() {
		return (
      <div>
        <div style={{maxWidth:'600px', margin:'auto'}}>
          <MenuCommunity />
        </div>

        <div style={{maxWidth:'600px', margin:'auto'}}>

          <div style={{textAlign:'right'}}>
            <span style={{color:'#666'}}>ページ{this.props.communityQa.page}</span>
            <IconButton
              onClick={ () => this.props.communityQaListGet(1) }
            >
              <RefreshIcon />
            </IconButton>
          </div>

          <div id='qa_list_block'>
          {
            (this.props.communityQa.datetime) && (
              (this.props.communityQa.list.length > 0) ? (
                <div>
                  {
                    (this.props.my.proof.credit === 0 && this.props.my.proof.person === 0 && this.props.communityQa.page !== 1) ? (
                      <div  align='center'>
                        <h2 align='center' style={{padding:'10px'}}>本人証明が申請されていない為<br/>これ以上は閲覧できません</h2>
                        <div align='center' style={{padding:'10px'}}>
                          <Button
                            variant="contained"
                            color='secondary'
                            onClick={ () => this.props.history.push('/my/proof/person') }
                          >
                            <div>
                              <div style={{fontSize:'1.4em'}}>本人証明を申請する</div>
                              <div>1分ほどで簡単に登録できます</div>
                            </div>
                          </Button>
                        </div>
                      </div>
                    ) : (
                      <div>
                        {
                          this.props.communityQa.list.map(
                            (value, index) => this._renderList(value, index)
                          )
                        }
                      </div>
                    )
                  }
                  <div style={{margin:'15px'}}>
                    <PartPagingNextPrev
                      page={this.props.communityQa.page}
                      isNext={this.props.communityQa.isListNext}
                      onClick={ (e) => this._onPaging(e) }
                    />
                  </div>

                </div>
              ): (
                <div>
                  <h2 align='center' style={{padding:'30px 0px'}}>
                    <span className='i-b'>Q&Aが見つかりませんでした</span>
                  </h2>
                </div>
              )
            )
          }
          </div>

      	</div>

        <div style={{height:'60px'}}></div>

        <div style={{position:'fixed',bottom:'0px',left:'0px',width:'100%', pointerEvents:'none'}}>
          <div style={{maxWidth:'900px', margin:'auto', textAlign:'right', pointerEvents:'none'}}>
            <Fab
              variant="extended"
              color="primary"
              onClick={ () => this.props.history.push('/my/qa/question/') }
              style={{margin:'10px', pointerEvents:'auto'}}
            >
              <CreateIcon />
              &nbsp;
              Q&Aを作る
            </Fab>
          </div>
        </div>

        <DialogQaAnswerAddConfirm
          open={ (this.state.answerAddQaId && this.state.answerAddText) ? true: false }
          pic={this.state.pic}
          answerAddQaId={this.state.answerAddQaId}
          answerAddText={this.state.answerAddText}
          apply={ (qaAnswerOpen) => this._partnerQaQuestionAnswerAddSubmit(qaAnswerOpen) }
          close={ () => this.setState({answerAddQaId: null, answerAddText:''}) }
        />

        <DialogConfirm
          open={ (this.state.answerDelQaId) ? true : false }
          title={'Q&Aの回答を削除'}
          content={'Q&Aの回答を削除してもいいですか？'}
          apply={ () => this._partnerQaQuestionAnswerDelSubmit() }
          close={ () => this.setState({answerDelQaId: null}) }
        />

      </div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
    my: state.my,
		communityQa: state.communityQa,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...communityQaAction,
		...partnerAction,
    ...partnerOperationAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
